import { createFileRoute } from '@tanstack/react-router'
import { LoanDetailScreen } from '@/features/loans/loan-detail'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/loans/$loanId')({
  beforeLoad: requirePermission('loans:read'),
  component: LoanDetailPage,
})

/** Detalle del préstamo: expediente, plan de pagos e historial. */
function LoanDetailPage() {
  const { loanId } = Route.useParams()
  return <LoanDetailScreen key={loanId} loanId={loanId} />
}
